import { Box } from "@material-ui/core";

export default function DashboardHeader() {
  return <Box>Dashboard</Box>;
}
